import { Box, Chip, List, ListItem, Typography } from "@mui/material";
import { lightBlue } from "@mui/material/colors";
import { FC } from "react";

import Loading from "web/Layout/Common/Loading";
import SubscriptionLinkMUI from "web/Layout/SubscriptionLink/subscriptionLinkMUI";
import __ from "web/Layout/Translations";

import dateFormatterWithDots from "web/utils/data/parser/dateAndTime/dateFormatterWithDots";
import convertToRomanNumeral from "web/utils/page/product/subscription/convertToRomanNumeral";

import { ProductInList } from "web/types/Product";
import {
  ChoiceButtonType,
  ISubscriptionUserInfoData,
} from "web/types/Subscription";

interface ISubscriptionBoxProps {
  data: ISubscriptionUserInfoData;
  listingData: ProductInList[];
  isLoading: boolean;
  hasError: boolean;
}

// TODO: determine behaviour on query error
const SubscriptionBoxMUI: FC<ISubscriptionBoxProps> = ({
  data,
  listingData,
  isLoading,
  hasError,
}) => {
  const { chooseSubscriptionsTo, startSubscriptionsFrom } = data || {};

  const finalDates = {
    fullDateToDate: dateFormatterWithDots(chooseSubscriptionsTo),
    fullDateFromDate: dateFormatterWithDots(startSubscriptionsFrom),
  };

  const listElement =
    listingData?.length > 0 ? (
      <List
        sx={{
          listStyleType: "disc",
          margin: "20px 0",
          height: "182px",
          overflowY: "auto",
          px: 2.5,
          "& li": {
            display: "list-item",
            listStyleType: "disc",
          },
          "&::-webkit-scrollbar": {
            width: "4px",
          },
          "&::-webkit-scrollbar-track": {
            boxShadow: "inset 0 0 6px #E0F7FA",
            borderRadius: "2px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#2C3E50",
            borderRadius: "2px",
          },
        }}
      >
        {listingData.map((eachBenefit) => {
          return (
            <ListItem
              sx={{ p: 0, py: 1, fontWeight: 800 }}
              key={eachBenefit.id}
            >
              {eachBenefit.name}
            </ListItem>
          );
        })}
      </List>
    ) : null;

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        width: "100%",
        p: { xs: 1.5, md: 3 },
        backgroundColor: lightBlue[50],
        maxWidth: "650px",
      }}
    >
      <Box sx={{ width: "100%" }}>
        <Typography sx={{ textAlign: "center", mb: 1 }} variant="h2">
          {__("Grupa")} {convertToRomanNumeral(data?.group)}
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              width: "100%",
              mihHeight: "91px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              mb: 1,
            }}
          >
            <Typography variant="subtitle2">
              {__("Wybieraj abonamenty do")}:
            </Typography>
            <Chip
              label={finalDates.fullDateToDate}
              color="info"
              size="medium"
              variant="filled"
              sx={{ mx: 1 }}
            />
          </Box>
          <Typography variant="caption">
            {__(`aby zostać nimi objętym od`)}:
            <Typography sx={{ ml: 0.5 }} variant="caption">
              {finalDates.fullDateFromDate}.
            </Typography>
          </Typography>
        </Box>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            minHeight: "100px",
          }}
        >
          {isLoading ? <Loading /> : listElement}
        </Box>

        {hasError ? __("Błąd pobierania danych.") : null}
        <Box>
          <SubscriptionLinkMUI
            disabled={!data.isWindowOpen}
            type={ChoiceButtonType.CHANGE_SUBSCRIPTIONS}
            group={data?.group}
            isBenefitListInThisGroupEmpty={false}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default SubscriptionBoxMUI;
